export const defaultCursorTrailItems = Object.freeze([
  {
    avif: "/img/portfolio/dinglandia.design--gilbertson-fine-homes.avif",
    webp: "/img/portfolio/dinglandia.design--gilbertson-fine-homes.webp",
  },
  {
    avif: "/img/portfolio/dinglandia-lab-rebrand.avif",
    webp: "/img/portfolio/dinglandia-lab-rebrand.webp",
  },
  {
    avif: "/img/portfolio/dinglandia.design--clayton-dog-walkers.avif",
    webp: "/img/portfolio/dinglandia.design--clayton-dog-walkers.webp",
  },
  {
    avif: "/img/portfolio/realtree-thumb.avif",
    webp: "/img/portfolio/realtree-thumb.webp",
  },
  {
    avif: "/img/portfolio/the-dawg-cafe-thumb.avif",
    webp: "/img/portfolio/the-dawg-cafe-thumb.webp",
  },
  {
    avif: "/img/portfolio/uptown-dawg.avif",
    webp: "/img/portfolio/uptown-dawg.webp",
  },
  {
    avif: "/img/portfolio/antons-pasta.avif",
    webp: "/img/portfolio/antons-pasta.webp",
  },
  {
    avif: "/img/portfolio/artisan-construction.avif",
    webp: "/img/portfolio/artisan-construction.webp",
  },
  {
    avif: "/img/portfolio/send-to-news.avif",
    webp: "/img/portfolio/send-to-news.webp",
  },
  {
    avif: "/img/portfolio/ixcela.avif",
    webp: "/img/portfolio/ixcela.webp",
  },
]);

export const workCursorTrailItems = Object.freeze([
  {
    avif: "/img/portfolio/dinglandia-lab-rebrand.avif",
    webp: "/img/portfolio/dinglandia-lab-rebrand.webp",
  },
  {
    avif: "/img/portfolio/dinglandia.design--gilbertson-fine-homes.avif",
    webp: "/img/portfolio/dinglandia.design--gilbertson-fine-homes.webp",
  },
  {
    avif: "/img/portfolio/dinglandia.design--labonlineagency-landing.avif",
    webp: "/img/portfolio/dinglandia.design--labonlineagency-landing.webp",
  },
  {
    avif: "/img/portfolio/dinglandia.design--clayton-dog-walkers.avif",
    webp: "/img/portfolio/dinglandia.design--clayton-dog-walkers.webp",
  },
  {
    avif: "/img/portfolio/realtree-thumb.avif",
    webp: "/img/portfolio/realtree-thumb.webp",
  },
  {
    avif: "/img/portfolio/the-dawg-cafe-thumb.avif",
    webp: "/img/portfolio/the-dawg-cafe-thumb.webp",
  },
  {
    avif: "/img/portfolio/uptown-dawg.avif",
    webp: "/img/portfolio/uptown-dawg.webp",
  },
  {
    avif: "/img/portfolio/antons-pasta.avif",
    webp: "/img/portfolio/antons-pasta.webp",
  },
  {
    avif: "/img/portfolio/artisan-construction.avif",
    webp: "/img/portfolio/artisan-construction.webp",
  },
  {
    avif: "/img/portfolio/send-to-news.avif",
    webp: "/img/portfolio/send-to-news.webp",
  },
  {
    avif: "/img/portfolio/ixcela.avif",
    webp: "/img/portfolio/ixcela.webp",
  },
]);
